// src/services/api/messageCenterShifts.js
import { apiClient } from './base';

export const getShiftTypes = async () => {
  try {
    const response = await apiClient.get('/message-center/shifts/shift-types');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShifts = async (params = {}) => {
  try {
    const response = await apiClient.get('/message-center/shifts', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShiftById = async (id) => {
  try {
    const response = await apiClient.get(`/message-center/shifts/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShiftDetails = async (id) => {
  try {
    const response = await apiClient.get(`/message-center/shifts/${id}/details`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShiftOrders = async (id, params = {}) => {
  try {
    const response = await apiClient.get(`/message-center/shifts/${id}/orders`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createShift = async (data) => {
  try {
    const response = await apiClient.post('/message-center/shifts', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateShift = async (id, data) => {
  try {
    const response = await apiClient.put(`/message-center/shifts/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
